import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Wrapper from "./esignThankYouPage.styles";
import environmentSettings from "../../../constants/environmentSettings";

export const EsignThankYouPage = () => {
  const dispatch = useDispatch();
  const { pdfUrlData, loanNetAdvance } = useSelector((state) => state.esign);
  const ref = useRef(null);
  const { companyName } = useSelector(
    (state) => state.StartUp.theme.configFile
  );

  const amount = parseFloat(loanNetAdvance).toFixed(2);

  useEffect(() => {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'esign',
      'value': amount,
      'currency': 'AUD'
    });

    return () => {
      if (pdfUrlData) {
        window.URL.revokeObjectURL(pdfUrlData.contract);
        window.URL.revokeObjectURL(pdfUrlData.repayment);
      }
    };
  }, [dispatch, pdfUrlData]);

  return (
    <Wrapper>
      <h1 className="congrats-title">Congratulations your loan is on it's way!</h1>
      {loanNetAdvance && <h1 className="congrats-title">${amount}</h1>}
      <h3>Great news - your loan application has been approved!</h3>
      <h3>
        You can expect a welcome email shortly with everything you need to know
        about your loan, including details on your repayments and how to manage your account.
      </h3>
      {companyName === 'Nimble' && (
        <h3>Thank you for choosing {companyName}. If you have any questions, our team is here to help!</h3>
      )}
      {companyName === "Fair Go Finance" && (
        <>
          <h3>Thank you for going forward with {companyName}. If you have any questions, our team is here to help!</h3>
          <div
            ref={ref}
            className="trustpilot-widget"
            data-locale="en-GB"
            data-template-id={environmentSettings.trustPilotDataId}
            data-businessunit-id={environmentSettings.trustPilotBusinessUnit}
            data-style-height="50px"
            data-style-width="100%"
            data-theme="light"
          >
            <a
              href={environmentSettings.trustPilotURL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Trustpilot
            </a>
          </div>
          <p>And if you have time, please rate your experience with us.</p>
        </>
      )}
    </Wrapper>
  );
};

export default EsignThankYouPage;
